import axios from "axios";
import config from "../../config/app.config";
import { setAuthorizationToken } from "../../helpers/axios";

setAuthorizationToken();

const ApiNotify = {
  getDataSetingNotify: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/notify/getDataSettingNotify`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await axios(resData);
  },
  getDataNotify: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/notify/getDataNotify`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await axios(resData);
  },
  sendnotify: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/notify/sendnotify`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  addRoomNotify: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/notify/addRoomTaleNotify`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  editingRoom: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/notify/editRoomTaleNotify`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  deleteRoom: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/notify/deleteRoom`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
};

export default ApiNotify;
